import { basePath, apiVersion } from './config';

export async function getPdfApi(token, id, pdfName, tenant) {
  const encodedName = encodeURIComponent(pdfName);
  const qs = tenant ? `?tenant=${encodeURIComponent(tenant)}` : '';
  const url = `${basePath}/${apiVersion}/download-portal/${id}&${encodedName}${qs}`;

  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
      'Content-Type': 'application/pdf',
    },
  };

  return await fetch(url, params)
    .then((response) => {
      return response;
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}
